import { createSlice } from "@reduxjs/toolkit";
import { logError } from "../Actions/ErrorActions";

const initialState = {
  isOpen: false,
  severity: "error",
  status: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  message: "",
};

const errorSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.message = action.payload.message;
      state.severity = action.payload.severity;
      state.isOpen = true;
    },
    closeModal: (state, action) => {
      state.message = "";
      state.isOpen = false;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(logError.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(logError.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(logError.fulfilled, (state, action) => {
        state.status = "succeeded";
      });
  },
});

export const { openModal, closeModal } = errorSlice.actions;

export default errorSlice.reducer;
